import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`王威作為領域驅動設計(DDD)的實踐者,是國內最早的事件風暴(Event Storming)的實踐者和倡導者。從 2014 年開始,王威已經在為國內企業提供事件風暴以及領域驅動設計方面的諮詢工作。2017 年,王威作為聯合發起人參與創建了領域驅動設計中國社群和領域驅動設計中國峰會`}<a parentName="p" {...{
        "href": "http://ddd-china.com/"
      }}>{`DDDChina Conference`}</a>{`,持續在向國內技術社群推廣 DDD 的實踐,並為企業提供相關諮詢服務。`}</p>
    <p>{`王威同時是 ThoughtWorks 中國區諮詢團隊數位技術戰略諮詢師和首席企業架構師。在過去的幾年中,王威曾先後為國內外電信、能源、銀行、保險、航運物流、汽車製造、物聯網、供應鏈管理等行業的全球領軍企業提供企業數位化轉型、數位技術戰略規劃、企業架構轉型、大型遺留系統重構規劃和實施、微服務架構轉型、自組織團隊建設、研發組織敏捷轉型、產品級敏捷轉型等服務。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      